module.exports = __webpack_public_path__ + "media/images/map-icons/open-osm-blackwhite-fbd3e925c3f3081cf9634116f336c83c.png";